/*
    filter 邏輯
    1. init(is_first=true) =>
        1. query_to_filter
        2. fetch_core_waybills
            1. filter_to_api_query
            2. axios
        if (is_first) {
            3. handle_quick_filter_key ui 決定要顯示哪個filter 樣式
        }
    2. filter() =>
        1. filter_to_query
        2. routes.push() 觸發 watch_routes()

    3. watch_routes() =>
        1. init(false)
 */
import moment from "moment"
import ResponseError from '@javascripts/response_error.js'

const store = {
    namespaced: true,
    state: {
        filter: {
            is_advanced_mode: false,
            shortcut_keys: [
                "staff_name", "begin_at", "end_at",
                "total_amount_from", "total_amount_to", "created_duration"
            ],
            current_shortcut_key: "staff_name",
            init_columns: {
                page: 1,
                staff_name: null,
                total_amount_from: null,
                total_amount_to: null,
                created_duration: "",
                created_at_from: null,
                created_at_to: null,
                begin_at: null,
                end_at: null,
            },
            columns: {}
        },
        is_selected: false,
        pagination: {},
        driver_commission_reports: [],
    },
    getters: {
        // filter 平面化 輸出一層object
        filter_to_query(state, getters, rootState, rootGetters) {
            let columns = _.cloneDeep(state.filter.columns)
            if (columns.page) delete columns.page
            if (columns.created_duration) {
                if (columns.created_duration[0]) columns.created_at_from = moment(columns.created_duration[0]).format("YYYY-MM-DD")
                if (columns.created_duration[1]) columns.created_at_to = moment(columns.created_duration[1]).format("YYYY-MM-DD")
                delete columns.created_duration
            }
            if (columns.begin_at) {
                columns.begin_at = moment(columns.begin_at).format("YYYY-MM-DDTHH:mm:ss")
            }
            if (columns.end_at) {
                columns.end_at = moment(columns.end_at).format("YYYY-MM-DDTHH:mm:ss")
            }
            return object_delete_null(columns)
        },
        filter_to_api_query(state, getters, rootState, rootGetters) {
            return (payload) => {
                let columns = _.cloneDeep(state.filter.columns)
                if (columns.created_duration) {
                    if (columns.created_duration[0]) columns.created_at_from = date_to_start(columns.created_duration[0])
                    if (columns.created_duration[1]) columns.created_at_to = date_to_end(columns.created_duration[1])
                    delete columns.created_duration
                }
                if (columns.begin_at) {
                    columns.begin_at = moment(columns.begin_at).format("YYYY-MM-DDTHH:mm:ss"+get_time_zone())
                }
                if (columns.end_at) {
                    columns.end_at = moment(columns.end_at).format("YYYY-MM-DDTHH:mm:ss"+get_time_zone())
                }
                return object_to_query(columns)
            }
        },
    },
    actions: {
        fetch_driver_commission_reports(context, payload) {
            context.commit('set_is_selected', false)
            let url = new RestUrl(context.rootState.provider.routes.api_v1_provider_driver_commission_reports).parse(
                {},
                ""
            )
            let api_query = context.getters.filter_to_api_query()
            if (api_query) url += `?${api_query}`

            console.log(url);
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    context.commit('set_is_selected', true)
                    if (response.data.status == "success") {
                        console.log(response.data);
                        context.commit('set_driver_commission_reports',
                            _.orderBy(response.data.driver_commission_reports, ['created_at'], ['desc'])
                        )
                        context.commit('set_pagination', response.data.pagination)
                    } else if (response.data.status == 'failure') {
                        return Promise.reject('fetch_driver_commission_reports_failure')
                    }
                })
                .catch(error => {
                    context.commit('set_is_selected', true)
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        // query 轉成 filter格式 並 merge 到 filter
        handle_query_to_filter(context, payload = {}) {
            if (payload.query) {
                let query = {..._.cloneDeep(context.state.filter.init_columns), ...payload.query}
                if (query.created_at_from && query.created_at_to) {
                    query.created_duration = [
                        moment(query.created_at_from) || "",
                        moment(query.created_at_to) || ""
                    ]
                    delete query.created_at_from
                    delete query.created_at_to
                }
                if (query.begin_at) {
                    query.begin_at = moment(query.begin_at).format("YYYY-MM-DDTHH:mm:ss")
                }
                if (query.end_at) {
                    query.end_at = moment(query.end_at).format("YYYY-MM-DDTHH:mm:ss")
                }
                context.state.filter.columns = {...context.state.filter.columns, ...query}
            }
        },
        // only run in init()
        handle_quick_filter_key(context, payload = {}) {
            let columns = object_delete_null(
                _.cloneDeep(context.state.filter.columns)
            )
            if (columns.page) delete columns.page

            let shortcut_key_occurrence_number = {
                number: 0,
                number_last_key: "",
            }

            context.state.filter.shortcut_keys.forEach((key) => {
                if(columns[key]) {
                    shortcut_key_occurrence_number.number += 1
                    shortcut_key_occurrence_number.number_last_key = key
                }
            })

            if (shortcut_key_occurrence_number.number == 1) {
                context.state.filter.current_shortcut_key =
                    shortcut_key_occurrence_number.number_last_key
            }

            if (
                (
                    shortcut_key_occurrence_number.number == 0 &&
                    Object.keys(columns).length >= 1
                ) || (
                    shortcut_key_occurrence_number.number >= 2
                )
            ) {
                context.state.filter.is_advanced_mode = true
            }
        },
    },
    mutations: {
        set_driver_commission_reports(state, payload) {
            state.driver_commission_reports = payload
        },
        set_is_selected(state, payload) {
            state.is_selected = payload
        },
        set_pagination(state, payload) {
            state.pagination = payload
        },
        init_filter_columns(state, payload) {
            state.filter.columns = _.cloneDeep(state.filter.init_columns)
        }
    }
}

export default store
